import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Loader } from 'src/ui/components/Loader/Loader';
import './image.scss';
import { IDENTIFIER_IMAGE } from 'src/ui/components/Image/constants';
// if src is null Image component doesn't handle it like an error and will display alternative text
export var Image = function (props) {
    var src = props.src, _a = props.alt, alt = _a === void 0 ? 'image' : _a, isLoading = props.isLoading, className = props.className, style = props.style, placeholderOnError = props.placeholderOnError, onClick = props.onClick, onLoad = props.onLoad, onError = props.onError, onMouseMove = props.onMouseMove, onMouseLeave = props.onMouseLeave;
    var _b = useState(false), errorOnLoad = _b[0], setErrorOnLoad = _b[1];
    useEffect(function () {
        if (src && errorOnLoad) {
            setErrorOnLoad(false);
        }
    }, [src]);
    var handleImageLoad = function (e) {
        setErrorOnLoad(false);
        if (onLoad) {
            onLoad(e);
        }
    };
    var handleImageError = function (e) {
        setErrorOnLoad(true);
        if (onError) {
            onError(e);
        }
    };
    if (errorOnLoad && placeholderOnError) {
        return placeholderOnError;
    }
    return isLoading ? (_jsx(Loader, { className: 'imageLoader' })) : (_jsx("img", { "data-test": IDENTIFIER_IMAGE, onLoad: handleImageLoad, onError: handleImageError, src: src, alt: alt, className: className, style: style, onClick: onClick, onDrag: function (e) { return e.preventDefault(); }, draggable: "false", onMouseMove: onMouseMove, onMouseLeave: onMouseLeave }));
};
